import Smooth from 'smoothscroll'
import scrollMonitor from 'scrollmonitor'

export default () => {
  const button = document.querySelector('.js-back-to-top')

  if (!button) return

  if (!button.classList.contains('active')) {
    window.addEventListener('scroll', function() {
      if (window.scrollY > 250) {
        button.classList.add('active')
      }
    })
  }

  button.addEventListener('click', e => {
    Smooth(0)
  })

}



// WEBPACK FOOTER //
// ./src/js/modules/BackToTop.js